import React from 'react';

export default function Stats() {
  return (
    <section className="bg-white">
      <div className="mx-auto max-w-screen-xl px-4 py-12 sm:px-6 md:py-16 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <h3 className="text-3xl font-bold text-gray-900 sm:text-4xl">
            Trusted by Aspiring Test Takers Worldwide
          </h3>

          <p className="mt-4 text-gray-500 sm:text-xl">
          PrepNexis AI is your ultimate partner for PTE preparation — empowering students with advanced tools and insights for guaranteed success.
          </p>
        </div>

        <div className="mt-8 sm:mt-12">
          <dl
            className="grid grid-cols-1 gap-4 sm:grid-cols-3 sm:divide-x sm:divide-gray-100"
          >
            <div className="flex flex-col px-4 py-8 text-center">
              <dt className="order-last text-lg font-medium text-gray-500">
                Successful Test Takers
              </dt>

              <dd className="text-4xl font-extrabold text-black md:text-5xl">
                50k+
              </dd>
            </div>

            <div className="flex flex-col px-4 py-8 text-center">
              <dt className="order-last text-lg font-medium text-gray-500">
                Practice Modules
              </dt>

              <dd className="text-4xl font-extrabold text-black md:text-5xl">
                30+
              </dd>
            </div>

            <div className="flex flex-col px-4 py-8 text-center">
              <dt className="order-last text-lg font-medium text-gray-500">
                AI Insights Delivered
              </dt>

              <dd className="text-4xl font-extrabold text-black md:text-5xl">
                500k+
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </section>
  );
}
